import React, { createContext, useContext, useMemo } from 'react';

import { FetchError } from '../../common/api/api';
import { useFindEntitySchemas } from './Entity.hooks';
import { EntitySchema } from './types';

export interface EntityContextState {
  schemas: EntitySchema[];
  isLoading: boolean;
  error?: FetchError;
}

const EntityContext = createContext<EntityContextState>({
  schemas: [],
  isLoading: false
});

export function useEntityContext(): EntityContextState {
  const context: EntityContextState = useContext(EntityContext);
  if (!context) {
    throw new Error(
      'useEntityContext must be used within the EntityProvider component.'
    );
  }
  return context;
}

const EntityProvider: React.FC = props => {
  const { children } = props;
  const { entitySchemas, isLoading, error, findEntitySchemas } =
    useFindEntitySchemas();

  // get schemas if not yet fetched
  const schemas = useMemo(() => {
    if (!entitySchemas) {
      findEntitySchemas();
      return [];
    }
    return entitySchemas;
  }, [entitySchemas, findEntitySchemas]);

  return (
    <EntityContext.Provider value={{ schemas, isLoading, error }}>
      {children}
    </EntityContext.Provider>
  );
};

export default EntityProvider;
